import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './en.json';
import { SUPPORTED_LANGUAGES, LOCALE_EN } from './constants';

const i18nConf = {
  fallbackLng: LOCALE_EN,
  detection: {
    order: ['localStorage', 'navigator'],
    caches: ['localStorage'],
  },
  supportedLngs: SUPPORTED_LANGUAGES,
  resources: {
    [LOCALE_EN]: { translation: en },
  },
  interpolation: {
    escapeValue: false, // Vue already safes from xss if we don't use v-html
  },
};

i18next
  .use(LanguageDetector)
  .init(i18nConf);

export default i18next;
